import { useMemo } from 'react';

import { AvatarStack } from '@/ui/Avatars/AvatarStack';
import { ChainAvatar, chainAvatarRadius } from '@/ui/Avatars/ChainAvatar';
import { LiquidityProviderAvatar } from '@/ui/Avatars/LiquidityProviderAvatar';

import { SUPPORTED_CHAINS_BY_CHAIN_ID } from '../../../constants/chain';
import { abbreviateNumber, floorDecimals } from '../../../utils/numbers';

export const LiquiditySourceChains = ({ chains }: { chains: string[] }) => {
  const chainIds = useMemo(() => chains.map((chain) => Number(chain)), [chains]);

  return (
    <div className="flex items-center">
      <AvatarStack size={16} overlap={2} borderRadius={chainAvatarRadius}>
        {chainIds.map((chainId) => (
          <ChainAvatar
            chainId={chainId}
            size={16}
            key={chainId}
            alt={`${SUPPORTED_CHAINS_BY_CHAIN_ID[chainId]?.name} logo`}
          />
        ))}
      </AvatarStack>
      <span className="ml-2 text-token-gray-1600">
        {chainIds.length > 1
          ? `${chainIds.length} networks`
          : ` ${SUPPORTED_CHAINS_BY_CHAIN_ID[chainIds[0]].name}`}
      </span>
    </div>
  );
};

export const LiquiditySourceRow = ({
  liquiditySource,
  volume,
  volume30D,
  chains,
  setSelectedSource,
}: {
  liquiditySource: string;
  chains: string[];
  volume: number;
  volume30D: number;
  setSelectedSource: (source: string) => void;
}) => (
  <tr
    className="font-body font-normal text-350 text-token-gray-800 border-b border-solid border-token-gray-300 cursor-pointer h-12 hover:bg-token-gray-100 active:bg-token-gray-100"
    onClick={() => setSelectedSource(liquiditySource)}
  >
    <td className="ml-8 my-[14px] mr-6 align-middle whitespace-nowrap pr-4 first:text-token-gray-1600 last:pr-8">
      <div className="flex items-center pl-8">
        <LiquidityProviderAvatar name={liquiditySource} size={18} />
        <span className="ml-2 text-token-gray-1600">{liquiditySource}</span>
      </div>
    </td>
    <td className="ml-8 my-[14px] mr-6 align-middle whitespace-nowrap pr-4 first:text-token-gray-1600 last:pr-8">
      ${volume > 1000 ? abbreviateNumber(volume, 1) : floorDecimals(volume, 0)}
    </td>
    <td className="ml-8 my-[14px] mr-6 align-middle whitespace-nowrap pr-4 first:text-token-gray-1600 last:pr-8">
      ${volume30D > 1000 ? abbreviateNumber(volume30D, 1) : floorDecimals(volume30D, 0)}
    </td>
    <td className="ml-8 my-[14px] mr-6 align-middle whitespace-nowrap pr-4 first:text-token-gray-1600 last:pr-8">
      <LiquiditySourceChains chains={chains} />
    </td>
  </tr>
);
